
export const setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorage = (key) => {
    const local = localStorage.getItem(key);
    return JSON.parse(local);
};